<ng-container *transloco="let t; read: 'blog-v250'">
  <h1>{{ t("title") }}</h1>
  <section class="article">
    <article>
      <h2>{{ t("online-title") }}</h2>
      <div class="text">
        <p>{{ t("online-intro") }}</p>
        <div class="hint">
          <h3>{{ t("hint-title") }}</h3>
          <p>{{ t("online-hint-text-01") }}</p>
          <p>{{ t("online-hint-text-02") }}</p>
        </div>
        <p>{{ t("online-content-01") }}</p>
        <img
          src="assets/v250-online01.png"
          alt="Online Publizieren"
          style="width: 600px"
        />
        <p>{{ t("online-content-02") }}</p>
        <img
          src="assets/v250-online02.png"
          alt="Online Publizieren vor dem ersten Aufruf"
          style="width: 600px"
        />
        <p>{{ t("online-content-03") }}</p>
        <img
          src="assets/v250-online03.png"
          alt="Erfolgreich publiziert"
          style="width: 400px"
        />
        <p>{{ t("online-content-04") }}</p>
        <img
          src="assets/v250-online04.png"
          alt="Online Publizieren nach dem ersten Aufruf"
          style="width: 600px"
        />
        <p>{{ t("online-content-05") }}</p>
      </div>
    </article>
    <article>
      <h2>{{ t("switch-video-title") }}</h2>
      <p>{{ t("switch-video-intro") }}</p>
      <p>{{ t("switch-video-content-01") }}</p>
      <img
        src="assets/v250-switch-video-01.png"
        alt="Neue Schaltfläche"
        style="width: 400px"
      />
      <p>{{ t("switch-video-content-02") }}</p>

      <img
        src="assets/v250-switch-video-02.png"
        alt="Neue Schaltfläche"
        style="width: 600px"
      />
      <div class="hint">
        <h3>{{ t("hint-title") }}</h3>
        <p>{{ t("switch-video-hint-text") }}</p>
      </div>
    </article>
    <article>
      <h2>{{ t("line-style-title") }}</h2>
      <p>{{ t("line-style-intro") }}</p>
      <img
        src="assets/v250-line-style-01.png"
        alt="Linienstile"
        style="width: 300px"
      />
    </article>
    <article>
      <h2>{{ t("rounded-title") }}</h2>
      <p>{{ t("rounded-intro") }}</p>
      <img
        src="assets/v250-rounded-01.png"
        alt="Abgerundetes Textfeld"
        style="width: 300px"
      />
      <p></p>
      <a [routerLink]="['/blog']" class="call">{{ t("back-to-blog") }}</a>
    </article>
  </section>
</ng-container>
